<template>
  <div id="ordinaryOrder">
    <div class="order-box">
      <div class="order-title">填写订单信息</div>
      <div class="table-box">
        <div style="height:31px"></div>
        <div class="address-box">
          <div class="address-title clearfix">
            <span style="float:left">收货地址</span>
            <!-- <span style="float:right;margin-right:14px;">管理收货地址</span> -->
            <router-link to="/user/address/0">
              <el-button type="text" size="small" style="float:right;margin-right:14px;">
                <i class="fas fa-edit"></i> 管理收货地址
              </el-button>
            </router-link>
          </div>
          <div class="address clearfix">
            <div class="show-address-info" v-show="is_address">
              <div class="address-pd">
                <span class="basic-font">收货人&nbsp;:&nbsp;</span>
                <span class="info-font">{{defaultAddress.name}}</span>
              </div>
              <div class="address-pd">
                <span class="basic-font">联系方式&nbsp;:&nbsp;</span>
                <span class="info-font">{{defaultAddress.mobile}}</span>
              </div>
              <div class="address-pd">
                <span class="basic-font">收货地址&nbsp;:&nbsp;</span>
                <span
                  class="info-font"
                >{{defaultAddress.province+" "+defaultAddress.city+" "+defaultAddress.area +" " + defaultAddress.address}}</span>
              </div>
            </div>
            <div class="address-button-box" v-show="is_address">
              <el-dropdown trigger="click">
                <div slot="reference" class="address-button" @click="shwoAddressList">
                  更改地址
                  <i class="iconfont" :class="iconUp?'icon-shang':'icon-xiala'"></i>
                </div>
                <el-button class="address-button">
                  更改地址
                  <i
                    style="font-size:10px;"
                    class="iconfont"
                    :class="iconUp?'icon-shang':'icon-xiala'"
                  ></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" style="width:500px;">
                  <div v-for="(item,index) of addressList" :key="index">
                    <el-dropdown-item>
                      <div style="border-bottom:1px solid #ddd;margin-bottom:10px;">
                        <el-row>
                          <el-col :span="21">
                            <div>
                              <div style="margin-bottom:10px;">{{item.name}} {{item.mobile}}</div>
                              <div
                                style="margin-bottom:10px;"
                              >{{item.province+" "+item.city+" "+item.area+" "+item.address}}</div>
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <div align="right">
                              <el-button plain size="mini" @click="changeAddress(item.id)">使用</el-button>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-popover @hide="changeUpIcon()" placement="bottom-end" width="500" trigger="click">
                <div>
                  <div v-for="(item,index) of addressList" :key="index">
                    <div style="border-bottom:1px solid #ddd;margin-bottom:10px;">
                      <el-row>
                        <el-col :span="21">
                          <div>
                            <div style="margin-bottom:10px;">{{item.name}} {{item.mobile}}</div>
                            <div
                              style="margin-bottom:10px;"
                            >{{item.province+" "+item.city+" "+item.area+" "+item.address}}</div>
                          </div>
                        </el-col>
                        <el-col :span="3">
                          <div align="right">
                            <el-button plain size="mini" @click="changeAddress(item.id)">使用</el-button>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
                <div slot="reference" class="address-button" @click="shwoAddressList">
                  更改地址
                  <i class="iconfont" :class="iconUp?'icon-shang':'icon-xiala'"></i>
                </div>
              </el-popover>-->
            </div>
            <div
              v-show="is_address1"
              style="font-size:18px;text-align:center;
            line-height:100px"
            >
              未设置收货地址，去
              <span style="color:#e2211c;cursor: pointer" @click="addFn">添加收货地址</span>
            </div>
          </div>
        </div>
        <div class="shop-list" v-for="(item,index) in orderInfo" :key="index">
          <div class="shop-title clearfix">
            <div class="shop-logo">
              <img :src="serve + item.shop.logo" alt />
            </div>
            <div class="shop-company">店铺&nbsp;:&nbsp;{{item.shop.company}}</div>
            <div class="table-title">
              <div class="title-item">小计</div>
              <div class="title-item">数量</div>
              <div class="title-item">单价</div>
            </div>
          </div>
          <div class="shop-table">
            <template>
              <el-table :show-header="false" :data="item.product" style="width: 100%">
                <el-table-column prop="date" width="650">
                  <template slot-scope="scope">
                    <div class="clearfix">
                      <div class="product-img">
                        <img :src="serve + scope.row.images" alt />
                      </div>
                      <div class="product-font">
                        <div class="product-title">{{scope.row.title}}</div>
                        <div class="product-item_no">货号 &nbsp;:&nbsp;{{scope.row.item_no}}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="150">
                  <template slot-scope="scope">
                    <div v-show="pay_type == 2 && scope.row.shop_id == 0" class="selling_price">
                      <span>￥{{Math.round(scope.row.selling_price * interest * 100) / 100}}</span>
                    </div>
                    <div
                      v-if="pay_type == 2 && scope.row.shop_id == 0"
                      class="selling_price"
                      style="color:red"
                    >
                      <span>现金价:{{scope.row.selling_price}}</span>
                    </div>
                    <div v-else class="selling_price">
                      <span>￥{{scope.row.selling_price}}</span>
                    </div>
                   
                    <div
                      v-if="parseInt(scope.row.number) > parseInt(scope.row.inventory) "
                      style="font-size:13px;color:#e2211c"
                    >库存不足，可预购！ </div>
                  </template>
                </el-table-column>
                <el-table-column width="150">
                  <template slot-scope="scope">
                    <div class="number">
                      <span>X{{scope.row.number}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="number" width="150">
                  <template slot-scope="scope">
                    <div
                      v-show="pay_type == 2 && scope.row.shop_id == 0"
                      class="selling_price"
                    >{{ Math.round(scope.row.number * ( Math.round(scope.row.selling_price * interest * 100) / 100) * 100) / 100 }}</div>
                    <div
                      v-if="pay_type == 2 && scope.row.shop_id == 0"
                      class="selling_price"
                      style="color:red"
                    >
                      <span>现金价:￥{{Math.round(scope.row.number * scope.row.selling_price * 100) / 100}}</span>
                    </div>
                    <div v-else class="item-total">
                      <span>￥{{ Math.round(scope.row.number * scope.row.selling_price* 100) / 100}}</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="note-box">
                <div class="note-title">给卖家留言&nbsp;:</div>
                <div class="input-box">
                  <el-input
                    type="textarea"
                    placeholder="选填:请和商家协商一致"
                    v-model="noteForm[index]"
                    maxlength="200"
                    show-word-limit
                    rows="3"
                  ></el-input>
                </div>
                <div class="total-money-box">
                  <span class="total">店铺合计&nbsp;:&nbsp;</span>
                  <span class="money">￥{{item.money}}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="pay-way-box" v-show="all_shop" v-if="is_open_payment">
          <div>支付方式</div>
          <div class="pay clearfix">
            <div
              @click="checkPayType(1)"
              class="pay-button"
              :class="pay_type == 1?'check-button':''"
            >在线支付</div>
            <div
              v-if="is_open_payment"
              @click="checkPayType(2)"
              class="pay-button"
              :class="pay_type == 2?'check-button':''"
            >账期支付</div>
            <div v-else class="pay-button not-allowed" :class="pay_type == 2?'check-button':''">账期支付</div>
            <div></div>
            <div v-if="pay_type == 2" class="not-open-alert">(您选择的账期为{{days}}天)</div>
            <div class="not-open-alert" v-if="!is_open_payment">(未开通，如需开通联系24小时电话:13761278568)</div>
          </div>
        </div>
        <div class="invoice-box">
          <div>发票信息</div>
          <div class="invoice clearfix">
            <div class="invoice-button">
              <el-checkbox v-model="invoiceChecked">是否开发票</el-checkbox>
            </div>
            <div class="invoce-content" v-show="invoiceId != 0">
              ({{invoiceForm.type}}&nbsp;/&nbsp;
              <span
                v-show="invoiceForm.type == '普通发票'"
              >{{invoiceForm.type1}}&nbsp;/&nbsp;</span>
              {{invoiceForm.name}})
            </div>
            <div class="change-add" @click="showInvoice = true" v-if="invoiceId != 0">修改</div>
            <div class="change-add" @click="showInvoice = true,invoiceAddress()" v-else>添加</div>
          </div>
        </div>
        <div class="coupon-box">
          <div>使用优惠券（0张）</div>
          <div class="coupon">
            <span style="margin-left:19px;">暂无可用优惠券</span>
          </div>
        </div>
        <div class="allInfo clearfix">
          <div class="title">全部信息</div>
          <div class="payment-title" v-if="pay_type == 2">
            您当前选择的是账期支付,如果您选择现金支付的话将
            <span
              class="big-font"
            >优惠:{{Math.round((payMoney - totalMoney)* 100) / 100}}元</span>
          </div>
          <div class="info">
            <div class="info-content">
              <div>{{all_number}}件</div>
              <!-- <div>{{buy_number}}件</div> -->
              <!-- <div>￥{{all_money}}</div> -->
              <div>-￥0</div>
              <div>￥0</div>
              <!-- <div style="font-size:20px;">￥{{payMoney}}</div> -->
              <div style="font-size:20px;">￥{{all_money}}</div>
            </div>
            <div class="info-title">
              <div>商品总数量&nbsp;:</div>
              <!-- <div>商品付款数量&nbsp;:</div> -->
              <!-- <div>商品总价&nbsp;:</div> -->
              <div>活动优惠&nbsp;:</div>
              <div>运费&nbsp;:</div>
              <div style="font-size:20px;">应付总额&nbsp;:</div>
            </div>
          </div>
        </div>
        <!-- <div
          style="padding:0 20px 20px 0;text-align: right;background:#fff"
        >实际付款金额不包含店铺商品，只包含自营商品 ，店铺商品还需商家与您进行下一步操作</div>-->
      </div>
      <div class="submit-box clearfix">
        <div class="submit-button" @click="submitOrder">提交订单</div>
      </div>
    </div>
    <el-dialog title="账期支付" :visible.sync="showPaymentList" width="200px">
      <span>
        <el-popover
          @show="checkDaysHover(items.interest)"
          style="display: block;margin-bottom:10px;"
          v-for="(items,index) in paymentDaysList"
          :key="index"
          placement="right"
          width="150px"
          height="10px"
          trigger="hover"
          :content="'应付总额'+ showPayMoney"
          :open-delay="0"
        >
          <el-button
            slot="reference"
            class="tag_days"
            @click="checkDays(items.days,items.interest)
              "
          >{{"账期为" + items.days + "天"}}</el-button>
        </el-popover>
      </span>
    </el-dialog>
    <el-dialog title="开票信息" :visible.sync="showInvoice" width="800px">
      <div>
        <div align="center" style="padding-bottom: 20px;">
          <el-radio-group v-model="invoiceForm.type" size="medium">
            <el-radio-button label="普通发票"></el-radio-button>
            <el-radio-button label="增值税发票"></el-radio-button>
          </el-radio-group>
        </div>
        <el-form label-position="right" label-width="200px" v-if="invoiceForm.type=='普通发票'">
          <el-form-item label="发票抬头：">
            <el-radio-group v-model="invoiceForm.type1" size="medium">
              <el-radio-button label="单位"></el-radio-button>
              <el-radio-button label="个人"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="invoiceForm.type1!='单位'" label="抬头名称：">
            <el-input v-model="invoiceForm.name" placeholder="填写个人发票名称" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item v-if="invoiceForm.type1 =='单位'" label="抬头名称：">
            <el-autocomplete
              style="width:300px"
              class="inline-input"
              v-model="invoiceForm.name"
              placeholder="填写单位名称"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete>
            <br />
          </el-form-item>
          <el-form-item v-if="invoiceForm.type1 == '单位'" label="纳税人识别号：">
            <el-input v-model="invoiceForm.tax_number" placeholder="填写纳税人识别号" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="自定义：" v-if="invoiceForm.content=='自定义'">
            <el-input v-model="invoiceForm.content2" placeholder="自定义开票内容" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="收票人姓名：">
            <el-input
              v-model="invoiceForm.invoice_name"
              placeholder="填写发票收货人姓名"
              style="width:300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="收票人电话：">
            <el-input
              v-model="invoiceForm.invoice_mobile"
              placeholder="填写发票收货人手机号"
              style="width:300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="收票人地址：">
            <el-input v-model="invoiceForm.address" placeholder="填写发票收货地址" style="width:300px"></el-input>
          </el-form-item>
        </el-form>
        <el-form
          align="left"
          label-position="right"
          label-width="200px"
          v-if="invoiceForm.type=='增值税发票'"
        >
          <el-form-item label="自定义：" v-if="invoiceForm.content=='自定义'">
            <el-input v-model="invoiceForm.content2" placeholder="自定义开票内容" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="单位名称：">
            <el-autocomplete
              style="width:400px"
              class="inline-input"
              v-model="invoiceForm.name"
              placeholder="填写单位名称"
              :autofocus="isAutofocus"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="纳税人识别号：">
            <el-input v-model="invoiceForm.tax_number" placeholder="填写纳税人识别号" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="注册地址：">
            <el-input
              v-model="invoiceForm.register_address"
              placeholder="填写注册地址"
              style="width:400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册电话：">
            <el-input v-model="invoiceForm.register_phone" placeholder="填写注册电话" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="开户银行：">
            <el-input v-model="invoiceForm.open_user_bank" placeholder="填写开户银行" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="银行账户：">
            <el-input
              v-model="invoiceForm.open_card_number"
              placeholder="填写银行账户"
              style="width:400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="收票人姓名：">
            <el-input v-model="invoiceForm.invoice_name" placeholder="填写收票人姓名" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="收票人电话：">
            <el-input
              v-model="invoiceForm.invoice_mobile"
              placeholder="填写收票人电话"
              style="width:400px"
            ></el-input>
          </el-form-item>
          <el-form-item label="收票地址：">
            <el-input v-model="invoiceForm.address" placeholder="填写收票地址" style="width:400px"></el-input>
          </el-form-item>
        </el-form>
        <div align="center" style="padding: 20px 0 20px 0;">
          <el-button @click="showInvoice = false">取消</el-button>
          <el-button type="primary" @click="submitInvoice">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="添加收货地址" :visible.sync="addDialog" width="800px" @closed="handleClose">
      <div>
        <el-row :gutter="40" class="row">
          <el-col :span="12">
            <el-input v-model="addform.name" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="addform.a_mobile" placeholder="请输入手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="row">
          <el-col :span="8">
            <el-select v-model="addform.province" placeholder="请选择" @change="change1">
              <el-option
                v-for="(item,index) in sel1"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="addform.city" placeholder="请选择" @change="change2">
              <el-option
                v-for="(item,index) in sel2"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="addform.area" placeholder="请选择">
              <el-option
                v-for="(item,index) in sel3"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <el-input type="textarea" v-model="addform.address" placeholder="请输入详细地址"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addsubmit" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="温馨提示" center :visible.sync="dialogVisible" width="30%">
      <div style="text-align:center">商品库存不足，订单为预购订单，是否继续？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitOrder1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      all_shop: true,
      loading: false,
      sel1: null,
      sel2: null,
      sel3: null,
      ddDialog: false,
      addform: {},
      addDialog: false,
      is_address: false,
      is_address1: false,
      all_number: "",
      buy_number: "",
      all_money: "",
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      carIds: this.$route.query.car_ids,
      p_id: this.$route.query.p_id,
      iconUp: false,
      addressList: [],
      defaultAddress: "",
      address_id: "",
      noteForm: [],
      orderInfo: [],
      pay_type: "",
      is_open_payment: false,
      paymentDaysList: [],
      showPaymentList: false,
      payMoney: 0,
      showPayMoney: 0,
      totalMoney: 0,
      interest: 1,
      days: 0,
      invoiceChecked: false,
      invoiceId: 0,
      invoiceForm: {
        type: "普通发票",
        type1: "单位",
        invoice_name: "",
        invoice_mobile: "",
        content: "订单明细",
        address: "",
        tax_number: ""
      },
      showInvoice: false,
      restaurants: [],
      isAutofocus: false
    };
  },
  activated() {
    this.getData();
  },
  created() {
    this.getDefaultAddress();
    this.getAddress();
    this.openPayment();
    this.getInvoice();
  },
  methods: {
    addsubmit() {
      this.loading = true;
      this.addform.mobile = this.$cookies.get("user");
      this.addform.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/member/add_address", {
          params: this.addform
        })
        .then(res => {
          this.addDialog = false;
          this.loading = false;
          if (res.data.status == "success") {
            this.$message({
              showClose: true,
              type: "success",
              message: "添加了一个新地址",
              offset: 400
            });
            this.getDefaultAddress();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleClose() {
      this.addform = {};
    },
    change1(v) {
      this.axios.get(this.serve + "/city?name=" + v).then(res => {
        this.sel2 = res.data;
      });
    },
    change2(v) {
      this.axios.get(this.serve + "/area?name=" + v).then(res => {
        this.sel3 = res.data;
      });
    },
    addFn() {
      this.axios.get(this.serve + "/province").then(res => {
        this.sel1 = res.data;
        this.addDialog = true;
      });
    },
    alertMessage(messsage, type) {
      this.$message({
        message: messsage,
        type: type,
        offset: 200
      });
    },
    invoiceAddress() {
      var defaultAddress = this.defaultAddress;
      if (defaultAddress != "") {
        this.invoiceForm.invoice_name = defaultAddress.name;
        this.invoiceForm.invoice_mobile = defaultAddress.mobile;
        this.invoiceForm.address =
          defaultAddress.province +
          " " +
          defaultAddress.city +
          " " +
          defaultAddress.area +
          " " +
          defaultAddress.address;
      }
    },
    submitOrder() {
      var orderinfo = this.orderInfo;
      for (var i in orderinfo) {
        let prod = orderinfo[i].product;
        for (var k in prod) {
          if (prod[k].inventory < prod[k].number) {
            this.dialogVisible = true;
            return;
          }
        }
      }
      var qs = require("qs");
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      var formData = {
        mobile: this.mobile,
        token: this.token,
        orderInfo: this.orderInfo,
        pay_type: this.pay_type,
        noteForm: this.noteForm
      };
      if (this.defaultAddress == "") {
        this.alertMessage("请添加收货地址", "error");
        return;
      } else {
        formData.address_id = this.address_id;
      }
      if (this.pay_type == "") {
        this.alertMessage("请选择支付方式", "error");
        return;
      } else if (this.pay_type == 2) {
        formData.days = this.days;
      }
      if (this.invoiceChecked) {
        if (this.invoiceId == 0) {
          this.alertMessage("请添加发票信息", "error");
          return;
        }
        formData.invoice_id = this.invoiceId;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在创建订单...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios
        .post(
          this.serve + "/member/newCreateOrder",
          qs.stringify(formData),
          config
        )
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            if (this.pay_type == 1) {
              this.$router.push("/user/pay?payOrder=" + data.data);
            } else if (this.pay_type == 2) {
              this.$router.push("/user/pay2?orders=" + data.data);
            }
          } else {
            this.$message({
              type : 'error',
              message : data.msg,
              offset : 200
            })
          }
          loading.close();
        });
    },

    submitOrder1() {
      this.dialogVisible = false;
      var qs = require("qs");
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      var formData = {
        mobile: this.mobile,
        token: this.token,
        orderInfo: this.orderInfo,
        pay_type: this.pay_type,
        noteForm: this.noteForm
      };
      if (this.defaultAddress == "") {
        this.alertMessage("请添加收货地址", "error");
        return;
      } else {
        formData.address_id = this.address_id;
      }
      if (this.pay_type == "") {
        this.alertMessage("请选择支付方式", "error");
        return;
      } else if (this.pay_type == 2) {
        formData.days = this.days;
      }
      if (this.invoiceChecked) {
        if (this.invoiceId == 0) {
          this.alertMessage("请添加发票信息", "error");
          return;
        }
        formData.invoice_id = this.invoiceId;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在创建订单...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios
        .post(
          this.serve + "/member/newCreateOrder",
          qs.stringify(formData),
          config
        )
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            if (this.pay_type == 1) {
              this.$router.push("/user/pay?payOrder=" + data.data);
            } else if (this.pay_type == 2) {
              this.$router.push("/user/pay2?orders=" + data.data);
            }
          } else {
            this.$message({
              type : 'error',
              message : data.msg,
              offset : 200
            })
          }
          loading.close();
        });
    },
    querySearch(queryString, cb) {
      var formData = {
        mobile: this.mobile,
        token: this.token,
        company: queryString
      };
      this.axios
        .get(this.serve + "/member/duty_code", {
          params: formData
        })
        .then(res => {
          this.restaurants = [];
          for (var item of res.data) {
            this.restaurants.push({
              value: item.company_name,
              address: item.duty_code
            });
          }
          cb(this.restaurants);
        });
    },
    handleSelect(item) {
      this.invoiceForm.tax_number = item.address;
    },
    submitInvoice() {
      var qs = require("qs");
      var formData = this.invoiceForm;
      formData.mobile = this.mobile;
      formData.token = this.token;
      if (formData.type == "普通发票") {
        formData.type = 1;
      } else if (formData.type == "增值税发票") {
        formData.type = 2;
      }
      if (formData.type == 1) {
        if (formData.type1 == "单位") {
          formData.type1 = 2;
        } else if (formData.type1 == "个人") {
          formData.type1 = 1;
        }
      }
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      this.axios
        .post(
          this.serve + "/member/create_invoice",
          qs.stringify(formData),
          config
        )
        .then(res => {
          this.iLoading = false;
          if (res.data.status == "success") {
            this.InvoiceId = res.data.data;
            this.alertMessage("开票信息已保存", "success");
            this.showInvoice = false;
            this.getInvoice();
          } else {
            this.alertMessage(res.data.msg, "error");
          }
        });
    },
    checkDays(days, interest) {
      this.pay_type = 2;
      this.interest = interest;
      this.showPaymentList = false;
      this.payMoney = this.getTotalMoney(this.orderInfo);
      //计算点击账期之后的总金额
      var all_money = 0;
      for (var i in this.orderInfo) {
        all_money += parseFloat(this.orderInfo[i].money);
      }
      this.all_money = Math.round(all_money * 100) / 100;

      this.days = days;
    },
    checkDaysHover(x) {
      var selling_price = 0;
      for (var i in this.orderInfo[0].product) {
        selling_price += parseFloat(
          Math.round(
            this.orderInfo[0].product[i].selling_price *
              this.orderInfo[0].product[i].number *
              x *
              100
          ) / 100
        );
      }
      this.showPayMoney = Math.round(selling_price * 100) / 100;
    },
    checkPayType(type) {
      if (type == 1) {
        this.getData();
        this.pay_type = type;
        this.interest = 1;
        this.payMoney = this.getTotalMoney(this.orderInfo);
      } else {
        var formData = {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token"),
          type: type
        };
        this.axios
          .get(this.serve + "/member/payment_days", {
            params: formData
          })
          .then(res => {
            this.paymentDaysList = res.data;
          });
        this.showPaymentList = true;
      }
    },
    shwoAddressList() {
      this.iconUp = !this.iconUp;
      this.$forceUpdate();
    },
    changeUpIcon() {
      this.iconUp = false;
    },
    getAddress() {
      var formData = {
        mobile: this.mobile,
        token: this.token
      };
      this.axios
        .get(this.serve + "/member/get_address", {
          params: formData
        })
        .then(res => {
          if (res.data.data.results == []) {
            this.addressList = [];
          } else {
            this.addressList = res.data.data.results;
          }
        });
    },
    getDefaultAddress() {
      this.is_address = false;
      this.is_address1 = false;
      var formData = {
        mobile: this.mobile,
        token: this.token
      };
      this.axios
        .get(this.serve + "/member/get_default_address2", {
          params: formData
        })
        .then(res => {
          if (res.data.status == "success") {
            this.defaultAddress = res.data.data;
            this.address_id = res.data.data.id;
            this.is_address = true;
          } else if (res.data.status == "error") {
            this.is_address1 = true;
          }
        });
    },
    changeAddress(id) {
      this.address_id = id;
      for (var item of this.addressList) {
        if (item.id == id) {
          this.defaultAddress = item;
        }
      }
    },
    getData() {
      var qs = require("qs");
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      var formData = {
        mobile: this.mobile,
        token: this.token
      };
      if (this.carIds) {
        var carIds = this.carIds;
        for (var i in carIds) {
          if (carIds[i] == null) {
            delete carIds[i];
          }
        }
        formData.carIds = carIds;
      } else if (this.p_id) {
        formData.p_id = this.p_id;
        formData.number = this.$route.query.number;
      }
      this.axios
        .post(
          this.serve + "/member/getOrderInfo",
          qs.stringify(formData),
          config
        )
        .then(res => {
          var data = res.data;
          var totalMoney = 0;
          var all_number = 0;
          var all_money = 0;
          if (data.status == "success") {
            var orderInfo = data.data;
            for (var i in orderInfo) {
              if (!orderInfo[i].product.length) {
                var arr = [];
                var key = Object.keys(orderInfo[i].product);
                for (var key_index in key) {
                  arr.push(orderInfo[i].product[key[key_index]]);
                }
                orderInfo[i].product = arr;
              }
              orderInfo[i].money = this.getShopMoney(orderInfo[i].product);
              all_money += parseFloat(orderInfo[i].money);
              for (var num in orderInfo[i].product) {
                all_number += parseInt(orderInfo[i].product[num].number);
              }

              if (orderInfo[0]) {
                var buy_number1111 = 0;
                var for_buy_num = orderInfo[0].product;
                for (var shop in for_buy_num) {
                  buy_number1111 += parseInt(for_buy_num[shop].number);
                }
                this.buy_number = buy_number1111;
                totalMoney = parseFloat(orderInfo[0].money);
              }
            }
            this.all_money = Math.round(all_money * 100) / 100;

            this.all_number = all_number;
            this.totalMoney = totalMoney;
            this.payMoney = totalMoney;
            this.orderInfo = orderInfo;
            var arr = [];
            for (var i in this.orderInfo) {
              arr.push(this.orderInfo[i].shop.id);
            }
            if (arr.indexOf("0") === -1) {
              this.all_shop = false;
              this.pay_type = 2;
            }
          } else {
          }
        });
    },
    getPaymentMonry(product, x) {},
    getShopMoney(product) {
      var money = 0;
      for (var i in product) {
        var items =
          (Math.round(product[i].selling_price * this.interest * 100) / 100) *
          product[i].number;
        money += items;
      }

      return Math.round(money * 100) / 100;

      // for (var i in product) {
      //   var item = parseFloat(
      //     (Math.round(product[i].selling_price * this.interest  * 100) /
      //       100) *
      //       product[i].number
      //   );

      //   money += parseFloat(Math.round(item * 100) / 100);
      // }
      // return Math.round(money * 100) / 100;
    },
    getTotalMoney(orderInfo) {
      var totalMoney = 0;
      // var all_money = 0;
      // for (var i in orderInfo) {
      //   orderInfo[i].money = this.getShopMoney(orderInfo[i].product);
      //   totalMoney += parseFloat(orderInfo[i].money);
      //   all_money += parseFloat(orderInfo[i].money);
      // }
      // this.all_money = all_money;
      orderInfo[0].money = this.getShopMoney(orderInfo[0].product);
      totalMoney += parseFloat(orderInfo[0].money);

      return Math.round(totalMoney * 100) / 100;
    },
    openPayment() {
      this.axios
        .get(this.serve + "/member/open_payment_days", {
          params: {
            mobile: this.mobile,
            token: this.token
          }
        })
        .then(res => {
          if (res.data == 0) {
            //未开通账期支付
            this.pay_type = 1;
            this.is_open_payment = false;
          } else {
            this.is_open_payment = true;
          }
        });
    },
    getInvoice() {
      this.axios
        .get(this.serve + "/member/last_invoice", {
          params: {
            mobile: this.mobile,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            var json = res.data.data;
            var _this = this;
            if (json.type == "1") {
              json.type = "普通发票";
            } else if (json.type == "2") {
              json.type = "增值税发票";
            }
            if (json.type1 == "1") {
              json.type1 = "个人";
            } else if (json.type1 == "2") {
              json.type1 = "单位";
            }
            _this.invoiceForm = json;
            this.invoiceId = json.id;
          }
        });
    }
  }
};
</script>
<style lang='scss'>
#ordinaryOrder {
  .clearfix:after  {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .row {
    margin-bottom: 20px;
  }
  width: 100%;
  border-top: 2px solid #e2211c;
  .order-box {
    width: 1200px;
    margin: 0 auto;
    .order-title {
      margin: 10px 0 9px 0;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .table-box {
      width: 1200px;

      background: rgba(254, 254, 254, 1);
      .address-box {
        width: 1100px;
        margin: 0 auto 0 auto;
        .address-title {
          margin-bottom: 15px;
        }
        .address {
          width: 1098px;
          height: 148px;
          background: rgba(254, 254, 254, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          .show-address-info {
            float: left;
            margin-left: 18px;
            margin-top: 18px;
            .basic-font {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
            }
            .info-font {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }
          }
          .address-pd {
            padding: 10px;
          }
          .address-button-box {
            float: right;
            padding: 52px 24px 52px 0;
            .address-button {
              width: 156px;
              height: 46px;
            }
            .address-button:hover {
              border: 1px solid rgba(226, 33, 28, 1);
              color: rgba(226, 33, 28, 1);
              background-color: white;
              cursor: pointer;
            }
          }
        }
      }
      .shop-list {
        margin-top: 38px;
        .shop-title {
          width: 1100px;
          margin: 0 auto;
          border-bottom: solid 1px #dddddd;
          padding-bottom: 12px;
          .shop-logo {
            float: left;
            width: 24px;
            height: 24px;
            img {
              width: 24px;
              height: 24px;
            }
          }
          .shop-company {
            float: left;
            line-height: 24px;
            margin-left: 5px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
          .table-title {
            float: right;
          }
          .title-item {
            float: right;
            width: 150px;
            line-height: 24px;
            text-align: center;
          }
        }
        .shop-table {
          width: 1100px;
          margin: 0 auto;
          .product-img {
            float: left;
            width: 82px;
            height: 82px;
            border: 1px solid rgba(221, 221, 221, 1);
            img {
              width: 80px;
              height: 80px;
            }
          }
          .product-font {
            float: left;
            margin-left: 12px;
            .product-title {
              font-size: 14px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 18px;
              width: 520px;
              /* overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis; */
            }
            .product-item_no {
              margin-top: 21px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
            }
          }
          .selling_price {
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          .number {
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          .item-total {
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          .note-box {
            width: 1100px;
            height: 86px;
            padding-top: 10px;
            margin-top: 20px;
            background: rgba(242, 247, 255, 1);
            .note-title {
              float: left;
              margin-left: 19px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }
            .input-box {
              float: left;
              width: 685px;
              height: 70px;
              background: rgba(254, 254, 254, 1);
            }
            .total-money-box {
              float: right;
              margin: 30px 40px 0 0;
              .total {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
              }
              .money {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(226, 33, 28, 1);
              }
            }
          }
        }
      }
      .pay-way-box {
        margin: 21px auto 0 auto;
        width: 1100px;
        .pay-title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .pay {
          margin-top: 14px;
          width: 1098px;
          height: 88px;
          background: rgba(254, 254, 254, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          .pay-button {
            width: 226px;
            height: 48px;
            float: left;
            margin-left: 30px;
            margin-top: 19px;
            background: rgba(245, 245, 245, 0);
            border: 1px solid rgba(221, 221, 221, 1);
            text-align: center;
            line-height: 48px;
            cursor: pointer;
          }
          .check-button {
            color: #e2211c;
            border: 1px solid rgba(226, 33, 28, 1);
          }
          .not-allowed {
            cursor: not-allowed;
          }
          .not-open-alert {
            float: left;
            margin: 38px 0 0 30px;
          }
        }
      }
      .invoice-box {
        margin: 21px auto 0 auto;
        width: 1100px;
        .invoice {
          width: 1098px;
          height: 88px;
          margin-top: 14px;
          background: rgba(254, 254, 254, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          .invoice-button {
            width: 226px;
            height: 48px;
            background: rgba(245, 245, 245, 0);
            border: 1px solid rgba(221, 221, 221, 1);
            margin-left: 30px;
            margin-top: 19px;
            text-align: center;
            line-height: 48px;
            cursor: pointer;
            float: left;
          }
          .invoce-content {
            float: left;
            line-height: 90px;
            margin-left: 50px;
          }
          .change-add {
            padding-left: 30px;
            padding-right: 30px;
            color: #e2211c;
            float: left;
            width: 40px;
            line-height: 90px;
            cursor: pointer;
          }
        }
      }
      .coupon-box {
        margin: 21px auto 0 auto;
        width: 1100px;
        .coupon {
          margin-top: 14px;
          width: 1098px;
          height: 56px;
          background: rgba(254, 254, 254, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          line-height: 56px;
        }
      }
      .allInfo {
        margin: 21px auto 0 auto;
        padding-bottom: 31px;
        width: 1100px;
        .title {
          padding-bottom: 15px;
          border-bottom: solid 1px #dddddd;
        }
        .payment-title {
          margin: 60px 0 0 200px;
          float: left;
          width: 470px;
          font-size: 20px;
          line-height: 2em;
          .big-font {
            font-size: 30px;
            color: #e2211c;
          }
        }
        .info {
          float: right;
          .info-title {
            margin-top: 13px;
            float: right;
            text-align: right;
            div {
              padding: 10px 0 10px 0;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: rgba(51, 51, 51, 1);
            }
          }
          .info-content {
            margin-top: 13px;
            float: right;
            text-align: right;
            margin-left: 50px;
            div {
              padding: 10px 0 10px 0;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: rgba(226, 33, 28, 1);
            }
          }
        }
      }
    }
    .submit-box {
      padding: 35px 0 60px 0;
      .submit-button {
        width: 180px;
        height: 46px;
        background: rgba(226, 33, 28, 1);
        border-radius: 4px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(254, 254, 254, 1);
        line-height: 46px;
        text-align: center;
        cursor: pointer;
        float: right;
      }
    }
  }
}
</style>